<template>
  <div class="wrapper" :style="{'min-height': !isMobileEnv ? 'auto' : docHt + 'px'}">
    <div class="container">
      <div class="store-list" v-if="shopList.length > 0">
        <div class="item" v-for="(item, index) in shopList" :key="index" @click="toJump(item)">
          <div class="store-name">{{item.shopName}}</div>
          <div class="address">{{item.addName}}</div>
          <div class="status-btn sign-btn" :class="item.shopStatus == 1110 || item.shopStatus == 1130 || item.shopStatus == 1131 || item.shopStatus == 1132 ? 'fail-btn' : item.shopStatus == 2001 ? 'complete-btn' : ''">{{item.shopStatusName}}</div>
          <div class="remark-btn" v-if="item.isBranch == 0">总店</div>
          <template v-if="item.shopStatus == 'STATUS_1033' || item.shopStatus == ' STATUS_1111' || item.shopStatus == ' STATUS_1132' || item.shopStatus == ' STATUS_1152'">
            <div class="line"></div>
            <div class="tips">很抱歉，因您的资质等问题，您的申请已被驳回，如有疑问，请联系客服人员。</div>
          </template>
        </div>
      </div>
      <div class="empty-cont" v-if="shopList.length < 1 && this.isShow">
        <img src="@/assets/images/empty-logo.png" class="empty-logo" />
        <p>请新建一个门店</p>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <router-link :to="{path: '/industry-info'}" class="add-btn">新建门店</router-link>
    </div>
  </div>
</template>
<script>
import { getShopList} from '@/api/baseinfo';
import { isMobileEnv } from '@/utils/index';
export default {
  name: 'storeList',
  data() {
    return {
      isQuick: sessionStorage.getItem('isQuick')||0,
      isVip: sessionStorage.getItem('isVip')||0,
      isShow: false,
      isMobileEnv: false,
      isMobile: false,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      shopList: [],
      statusList: []
    }
  },
  created() {
    this.isMobileEnv = isMobileEnv();
    this.mobileTerminal((data) => {
      this.isMobile = data;
    })
    this.getShopList();
    setTimeout(() => {
      this.isShow = true;
    }, 1500);
  },
  methods: {
    getShopList() {
      getShopList().then(res => {
        if(res.data.length > 0) {
          this.shopList = res.data;
          this.isShow = false;
        } else {
          this.shopList = [];
          this.isShow = true;
        }
      })
    },
    toJump(data) {
      if(this.isVip==1){  // 专属入驻
        if(data.shopStatus == 1030 || data.shopStatus == 1032 || data.shopStatus == 1050) {
          this.$router.push({
            path: '/lease-type?shopCode=' + data.shopCode
          })
        }
      } else {
        if(this.isQuick==1){
          if(data.shopStatus == 1030 || data.shopStatus == 1032 || data.shopStatus == 1050) {
            this.$router.push({
              path: '/apply-package?shopCode=' + data.shopCode + '&shopCategory='+ data.shopCategory
            })
          }
        } else {
          if(data.shopStatus == 1030 || data.shopStatus == 1032) {
            this.$router.push({
              path: '/register-results?shopCode=' + data.shopCode
            })
          } else if(data.shopStatus == 1050) {
            this.$router.push({
              path: '/apply-package?shopCode=' + data.shopCode
            })
          }
        }
      }

      if(data.shopStatus == 1070) {
        this.$router.push({
          path: '/payment?shopCode=' + data.shopCode
        })
      } else if(data.shopStatus == 1090) {
        this.$router.push({
          path: '/baseinfo-auth?shopCode=' + data.shopCode
        })
      } else if(data.shopStatus == 1110 || data.shopStatus == 1130 || data.shopStatus == 1131 || data.shopStatus == 1132) {
        this.$router.push({
          // path: '/apply-results?shopCode=' + data.shopCode
          path: '/appId?shopCode=' + data.shopCode,
        })
      } else if(data.shopStatus == 2001) {
        this.$router.push({
          // path: '/apply-passed?shopCode=' + data.shopCode
          path: '/appId?shopCode=' + data.shopCode
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: 1px;
  }
  .store-list{
    margin-top: 1rem;
    padding-bottom: 5.5rem;
    .item{
      width: 16.75rem;
      background: #FFFFFF;
      border-radius: .5rem;
      border: 1px solid #D8E0F0;
      padding: 1.1rem 1rem 1rem;
      box-sizing: border-box;
      margin: 0 auto 1rem;
      position: relative;
      &:last-child{
        margin-bottom: 0;
      }
      .remark-btn{
        width: 2.4rem;
        height: 1.2rem;
        line-height: 1.2rem;
        background: #FFFFFF;
        border-radius: .2rem;
        border: 1px solid #C1CBD7;
        font-size: .7rem;
        color: #7D8592;
        text-align: center;
        position: absolute;
        top: 1rem;
        right: 1rem;
      }
      .store-name{
        line-height: 1;
        font-size: 1rem;
        color: #222;
        font-weight: 500;
        margin-bottom: .3rem;
      }
      .address{
        line-height: 1.4;
        font-size: .7rem;
        color: #8F8F94;
        margin-bottom: .7rem;
      }
      .link-a{
        font-size: .7rem;
        color: $base-color;
      }
      .status-btn{
        font-size: .7rem;
      }
      .complete-btn{
        color: #27D158;
      }
      .fail-btn{
        color: #FF4743;
      }
      .sign-btn{
        color: $base-color;
      }
      .line{
        width: 15.75rem;
        height: 0;
        border-bottom: 1px solid #EEEEEE;
        margin: .7rem auto .6rem;
      }
      .tips{
        line-height: 1.5;
        font-size: .7rem;
        color: #8F8F94;
        text-align: left;
      }
    }
  }
  .add-btn{
    width: 15rem;
    height: 2.2rem;
    line-height: 2.2rem;
    background: #47B6C7;
    border-radius: .4rem;
    margin: 0 auto;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    cursor: pointer;
    display: block;
  }
  .empty-cont{
    text-align: center;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    .empty-logo{
      width: 70px;
      height: 70px;
      display: block;
      margin: 0 auto;
    }
    p{
      font-size: 14px;
      color: #7D8592;
      text-align: center;
      margin-top: 10px;
    }
  }
}
@media screen and (min-width:750px){
  .store-list{
    margin-top: 20px;
    padding-bottom: 110px;
    .item{
      width: 335px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #D8E0F0;
      padding: 22px 20px 20px;
      box-sizing: border-box;
      margin: 0 auto 20px;
      position: relative;
      &:last-child{
        margin-bottom: 0;
      }
      NaNpxark-btn{
        width: 48px;
        height: 24px;
        line-height: 24px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #C1CBD7;
        font-size: 14px;
        color: #7D8592;
        text-align: center;
        position: absolute;
        top: 20px;
        right: 20px;
      }
      .store-name{
        line-height: 1;
        font-size: 20px;
        color: #222;
        font-weight: 500;
        margin-bottom: 6px;
      }
      .address{
        line-height: 1.4;
        font-size: 14px;
        color: #8F8F94;
        margin-bottom: 14px;
      }
      .link-a{
        font-size: 14px;
        color: $base-color;
      }
      .status-btn{
        font-size: 14px;
      }
      .complete-btn{
        color: #27D158;
      }
      .fail-btn{
        color: #FF4743;
      }
      .sign-btn{
        color: $base-color;
      }
      .line{
        width: 315px;
        height: 0;
        border-bottom: 1px solid #EEEEEE;
        margin: 14px auto 12px;
      }
      .tips{
        line-height: 1.5;
        font-size: 14px;
        color: #8F8F94;
        text-align: left;
      }
    }
  }
  .add-btn{
    width: 300px;
    height: 44px;
    line-height: 44px;
    background: #47B6C7;
    border-radius: 8px;
    margin: 0 auto;
    font-size: 16px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    display: block;
  }
  .empty-cont{
    text-align: center;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    .empty-logo{
      width: 70px;
      height: 70px;
      display: block;
      margin: 0 auto;
    }
    p{
      font-size: 14px;
      color: #7D8592;
      text-align: center;
      margin-top: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/store-list.vue